import React__default from "react";
import { parseDiff, Diff, Hunk } from "react-diff-view";
import { formatLines, diffLines } from "unidiff";
import "../../node_modules/react-diff-view/style/index.css.js";
import { corePluginHooks } from "../core/index.js";
import { diffSourcePluginHooks } from "./index.js";
const DiffViewer = () => {
  const [newText] = corePluginHooks.useEmitterValues("markdown");
  const [oldText] = diffSourcePluginHooks.useEmitterValues("diffMarkdown");
  const diffText = formatLines(diffLines(oldText, newText), { context: 3 });
  if (diffText.trim() === "")
    return /* @__PURE__ */ React__default.createElement("div", null, "No changes");
  const [diff] = parseDiff(diffText, { nearbySequences: "zip" });
  return /* @__PURE__ */ React__default.createElement(Diff, { viewType: "split", diffType: "modify", hunks: diff.hunks || [] }, (hunks) => hunks.map((hunk) => /* @__PURE__ */ React__default.createElement(Hunk, { key: hunk.content, hunk })));
};
export {
  DiffViewer
};
